module.exports = __webpack_public_path__ + "img/logo.44998acc.svg";